import { useEffect, useState } from "react";
import { useStartCalculationMutation } from "./results";

export function useStartCalculation(caseId: string | number) {
  const mutation = useStartCalculationMutation(caseId);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    if (mutation.error) return setIsDialogOpen(true);
    return setIsDialogOpen(false);
  }, [mutation.error]);

  return {
    isDialogOpen,
    setIsDialogOpen,
    mutation,
  };
}
